/**
 * @generated SignedSource<<7e2daf33a071678b3a7efcf6c9aeedc0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Action = "ACCEPT_EVENT_INVITE" | "ADD_COMPETITION_JURY" | "ADD_COMPETITION_MEMBER" | "ADD_EVENT_COMPETITION" | "ADD_EVENT_MEMBER" | "ADD_PROVIDER_PLATFORM_MEMBER" | "AWARD_BADGE" | "BOOKMARK_PAPER" | "CANCEL_PROVIDER_JOB" | "CREATE_ANNOUNCEMENT" | "CREATE_BLOG_ARTICLE" | "CREATE_COMMENT" | "CREATE_COMPETITION" | "CREATE_COMPETITION_RULE_AGREEMENT" | "CREATE_COMPETITION_STAGE" | "CREATE_COMPETITION_TEAM_REQUEST" | "CREATE_DATASET" | "CREATE_DATASET_COMPETITION" | "CREATE_DATASET_MEMBER" | "CREATE_DATASET_VERSION" | "CREATE_DATA_CATALOG" | "CREATE_DATA_CATALOG_DATASET" | "CREATE_EVENT" | "CREATE_EVENT_RULE_AGREEMENT" | "CREATE_FORUM" | "CREATE_OAUTH_2_CONFIG" | "CREATE_ORGANIZATION" | "CREATE_PROJECT_VERSION_APPROVAL" | "CREATE_SUBJECT_SUBSCRIPTION" | "CREATE_SUBMISSION_VERSION" | "CREATE_TAG" | "CREATE_TOPIC" | "CREATE_USE_CASE_VERSION" | "CREATE_WORKSPACE" | "CREATE_WORKSPACE_VERSION" | "DELETE_BLOG_ARTICLE" | "DELETE_COMMENT" | "DELETE_COMPETITION" | "DELETE_COMPETITION_TEAM_REQUEST" | "DELETE_DATASET" | "DELETE_DATASET_COMPETITION" | "DELETE_DATASET_MEMBER" | "DELETE_DATASET_VERSION" | "DELETE_DATA_CATALOG" | "DELETE_DATA_CATALOG_DATASET" | "DELETE_EVENT" | "DELETE_FORUM" | "DELETE_OAUTH_2_CONFIG" | "DELETE_ORGANIZATION" | "DELETE_PROJECT_VERSION_APPROVAL" | "DELETE_SUBJECT_SUBSCRIPTION" | "DELETE_TAG" | "DELETE_TOPIC" | "DELETE_USER" | "DELETE_WORKSPACE" | "DELETE_WORKSPACE_VERSION" | "FETCH_WEBSITE_METADATA" | "HIDE_ANNOUNCEMENT" | "JOIN_COMPETITION" | "JOIN_EVENT" | "MANAGE_ENTITY_BAN" | "MANAGE_EVENT_INVITE_CODE" | "PIN_EVENT_COMPETITION" | "PUBLISH_DATASET_VERSION" | "PUBLISH_VOTE" | "PUBLISH_WORKSPACE_VERSION" | "READ_ACTIVITY_TRACKER" | "READ_COMMENT" | "READ_COMPETITION" | "READ_COMPETITION_MEMBERSHIP" | "READ_COMPETITION_PRIVATE_APPROVAL" | "READ_COMPETITION_RULE" | "READ_COMPETITION_RULE_AGREEMENT" | "READ_COMPETITION_SCORING_CRITERION" | "READ_DATASET" | "READ_DATASET_MEMBER" | "READ_DATASET_VERSION" | "READ_DATASET_VERSION_FILE" | "READ_DATA_CATALOG" | "READ_EVENT" | "READ_EVENT_COMPETITION" | "READ_EVENT_INVITATION" | "READ_EVENT_MEMBERSHIP" | "READ_EVENT_RULE" | "READ_EVENT_RULE_AGREEMENT" | "READ_OAUTH_2_CONFIG" | "READ_OAUTH_2_CONFIG_SECRET" | "READ_PAPER_AUTHOR_EMAILS" | "READ_PROJECT_VERSION" | "READ_PROJECT_VERSION_APPROVAL" | "READ_PROJECT_VERSION_APPROVAL_SCORE" | "READ_PROJECT_VERSION_EVALUATION" | "READ_PROJECT_VERSION_FILE" | "READ_PROVIDER_JOB" | "READ_PROVIDER_PLATFORM_MEMBERSHIP" | "READ_RESOURCE_USAGE" | "READ_STORAGE" | "READ_SUBJECT_SUBSCRIPTION" | "READ_SUBMISSION" | "READ_TOPIC" | "READ_USER_EMAIL" | "READ_USER_NOTIFICATIONS" | "READ_USER_PERMISSIONS" | "READ_WORKSPACE" | "READ_WORKSPACE_VERSION" | "REEVALUATE_COMPETITION" | "REMOVE_COMPETITION_JURY" | "REMOVE_COMPETITION_MEMBER" | "REMOVE_COMPETITION_STAGE" | "REMOVE_EVENT_COMPETITION" | "REMOVE_EVENT_MEMBER" | "REMOVE_ORGANIZATION_MEMBER" | "REMOVE_PROVIDER_PLATFORM_MEMBER" | "REQUEST_PAPER_ASSESSMENT" | "SEND_COMPETITION_TEAM_REQUEST_MESSAGE" | "SET_COMPETITION_ORDERING_PRIORITY" | "SET_EVENT_ORDERING_PRIORITY" | "SUBMIT_PROVIDER_JOB" | "TRANSFER_COMPETITION_OWNERSHIP" | "TRANSFER_DATASET_OWNERSHIP" | "TRANSFER_EVENT_OWNERSHIP" | "TRANSFER_ORGANIZATION_OWNERSHIP" | "TRANSFER_WORKSPACE_OWNERSHIP" | "UPDATE_AGENDA" | "UPDATE_BLOG_ARTICLE" | "UPDATE_COMMENT" | "UPDATE_COMPETITION" | "UPDATE_COMPETITION_MEMBER" | "UPDATE_COMPETITION_STAGE" | "UPDATE_COMPETITION_TEAM_REQUEST" | "UPDATE_DATASET" | "UPDATE_DATASET_MEMBER" | "UPDATE_DATASET_VERSION" | "UPDATE_DATA_CATALOG" | "UPDATE_EVENT" | "UPDATE_FORUM" | "UPDATE_OAUTH_2_CONFIG" | "UPDATE_ORGANIZATION" | "UPDATE_ORGANIZATION_MEMBERSHIP" | "UPDATE_PROJECT_VERSION" | "UPDATE_PROJECT_VERSION_APPROVAL" | "UPDATE_PROJECT_VERSION_FILE" | "UPDATE_TOPIC" | "UPDATE_USER" | "UPDATE_WORKSPACE" | "UPDATE_WORKSPACE_VERSION" | "UPLOAD_FILES" | "UPLOAD_PROVIDER_MODEL" | "VIEW_PAPER" | "WRITE_STORAGE";
import { UsernameOrID } from "@/common/relayCustomScalar";
export type Permission = {
  actingAs?: UsernameOrID | null | undefined;
  on?: string | null | undefined;
  to: Action;
};
export type UserEntitiesAutocompleteFragmentPaginationQuery$variables = {
  count?: number | null | undefined;
  id: string;
  permission?: Permission | null | undefined;
  search?: string | null | undefined;
};
export type UserEntitiesAutocompleteFragmentPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"UserEntitiesAutocompleteFragment">;
  };
};
export type UserEntitiesAutocompleteFragmentPaginationQuery = {
  response: UserEntitiesAutocompleteFragmentPaginationQuery$data;
  variables: UserEntitiesAutocompleteFragmentPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "permission"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "kind": "Variable",
  "name": "permission",
  "variableName": "permission"
},
v6 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserEntitiesAutocompleteFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "kind": "FragmentSpread",
            "name": "UserEntitiesAutocompleteFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "UserEntitiesAutocompleteFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*:: as any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "count"
                  },
                  (v5/*:: as any*/),
                  (v6/*:: as any*/)
                ],
                "concreteType": "UserEntitiesConnection",
                "kind": "LinkedField",
                "name": "entities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*:: as any*/),
                          (v8/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "kind",
                            "storageKey": null
                          },
                          (v9/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "47a44ab4eb4b5a53eda42254d003ecad",
    "id": null,
    "metadata": {},
    "name": "UserEntitiesAutocompleteFragmentPaginationQuery",
    "operationKind": "query",
    "text": "query UserEntitiesAutocompleteFragmentPaginationQuery(\n  $count: Int = 10\n  $permission: Permission\n  $search: String\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...UserEntitiesAutocompleteFragment_2YZHm4\n    id\n  }\n}\n\nfragment UserEntitiesAutocompleteFragment_2YZHm4 on User {\n  id\n  username\n  entities(first: $count, search: $search, permission: $permission) {\n    edges {\n      node {\n        __typename\n        id\n        kind\n        username\n        displayName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3950ac25c2feeaedc166c0adf6411319";

export default node;
